import React, {useState} from 'react';
import {  Video as TikTokIcon,
  Youtube,
  Trash2,
  X,
  Download, Pause,Play,
  ExternalLink as LinkIcon,
  Volume2,
  VolumeX,
  Upload,
  Instagram,
  Copy,
  Check
   } from 'lucide-react';
import {  motion , AnimatePresence} from 'framer-motion';

const VideoShowcaseStatusIndicator = ({ isPublished, platform }) => {
  let Icon;
  switch (platform) {
    case 'YouTube':
      Icon = Youtube;
      break;
    case 'TikTok':
      Icon = TikTokIcon;
      break;
    case 'Instagram':
      Icon = Instagram;
      break;
    default:
      Icon = TikTokIcon;
  }

  return (
      <div
          className={`flex items-center space-x-2 ${
              isPublished ? 'text-green-500' : 'text-gray-400'
          }`}
      >
        <Icon size={16} />
        <span className="text-xs font-medium">
        {isPublished ? 'Published' : 'Not Published'}
      </span>
      </div>
  );
};

export default VideoShowcaseStatusIndicator;
